export const EventType = {
  FREE_FLOW: 'FREE_FLOW',
  WORKSHOP: 'WORKSHOP',
};

export const eventTypes = [
  EventType.FREE_FLOW,
  EventType.WORKSHOP,
];
